export const CHECK_ADDRESS_DELIVERY_REDUCER_KEY = 'checkAddressDelivery';
